import countriesDE from 'i18n-iso-countries/langs/de.json'
import countriesEN from 'i18n-iso-countries/langs/en.json'
import countriesES from 'i18n-iso-countries/langs/es.json'
import countriesFR from 'i18n-iso-countries/langs/fr.json'
import countriesHU from 'i18n-iso-countries/langs/hu.json'
import countriesNL from 'i18n-iso-countries/langs/nl.json'
import countriesPL from 'i18n-iso-countries/langs/pl.json'
import countriesRO from 'i18n-iso-countries/langs/ro.json'
import countries from 'i18n-iso-countries'

countries.registerLocale(countriesDE)
countries.registerLocale(countriesEN)
countries.registerLocale(countriesES)
countries.registerLocale(countriesFR)
countries.registerLocale(countriesHU)
countries.registerLocale(countriesNL)
countries.registerLocale(countriesPL)
countries.registerLocale(countriesRO)
